module.exports = __webpack_public_path__ + "static/media/ic_hanger_door.19798162.svg";